import { useState } from 'react';
import { useDispatch } from 'react-redux';
import { updateCustomer } from '../../redux/slices/customersSlice';
import { useLanguage } from '../../context/LanguageContext';

const CustomerDetails = ({ data, onRefetch }) => {
  const dispatch = useDispatch();
  const { t } = useLanguage();
  const [isEditing, setIsEditing] = useState(false);
  const [form, setForm] = useState(null);

  const startEdit = () => {
    setForm({
      name: data.name || '',
      email: data.email || '',
      tel: data.tel || '',
      street: data.street || '',
      house_number: data.house_number || '',
      zip: data.zip || '',
      city: data.city || '',
    });
    setIsEditing(true);
  };

  const handleSave = (e) => {
    e.preventDefault();
    dispatch(updateCustomer({ id: data.id, data: form }))
      .unwrap()
      .then(() => {
        setIsEditing(false);
        onRefetch?.();
      })
      .catch((err) => console.error('Failed to save customer:', err));
  };

  if (isEditing) {
    return (
      <form onSubmit={handleSave} className='space-y-4'>
        <div>
          <label className='block text-sm font-medium text-gray-700 mb-2'>{t('common.name')} *</label>
          <input
            type='text'
            value={form.name}
            onChange={(e) => setForm({ ...form, name: e.target.value })}
            className='input-field'
            required
          />
        </div>
        <div className='grid grid-cols-2 gap-4'>
          <div>
            <label className='block text-sm font-medium text-gray-700 mb-2'>{t('customers.email')}</label>
            <input
              type='email'
              value={form.email}
              onChange={(e) => setForm({ ...form, email: e.target.value })}
              className='input-field'
            />
          </div>
          <div>
            <label className='block text-sm font-medium text-gray-700 mb-2'>{t('customers.phone')}</label>
            <input
              type='text'
              value={form.tel}
              onChange={(e) => setForm({ ...form, tel: e.target.value })}
              className='input-field'
            />
          </div>
        </div>
        <div className='grid grid-cols-3 gap-4'>
          <div className='col-span-2'>
            <label className='block text-sm font-medium text-gray-700 mb-2'>{t('customers.street')}</label>
            <input
              type='text'
              value={form.street}
              onChange={(e) => setForm({ ...form, street: e.target.value })}
              className='input-field'
            />
          </div>
          <div>
            <label className='block text-sm font-medium text-gray-700 mb-2'>{t('customers.number')}</label>
            <input
              type='text'
              value={form.house_number}
              onChange={(e) => setForm({ ...form, house_number: e.target.value })}
              className='input-field'
            />
          </div>
        </div>
        <div className='grid grid-cols-3 gap-4'>
          <div>
            <label className='block text-sm font-medium text-gray-700 mb-2'>{t('customers.zip')}</label>
            <input
              type='text'
              value={form.zip}
              onChange={(e) => setForm({ ...form, zip: e.target.value })}
              className='input-field'
            />
          </div>
          <div className='col-span-2'>
            <label className='block text-sm font-medium text-gray-700 mb-2'>{t('customers.city')}</label>
            <input
              type='text'
              value={form.city}
              onChange={(e) => setForm({ ...form, city: e.target.value })}
              className='input-field'
            />
          </div>
        </div>
        <div className='flex justify-end space-x-3 pt-2'>
          <button type='button' onClick={() => setIsEditing(false)} className='btn-secondary'>
            {t('common.cancel')}
          </button>
          <button type='submit' className='btn-primary'>
            {t('customers.saveChanges')}
          </button>
        </div>
      </form>
    );
  }

  return (
    <div className='space-y-6'>
      <div className='bg-gray-50 rounded-lg p-4'>
        <div className='flex items-center justify-between mb-4'>
          <h3 className='text-lg font-semibold text-gray-900'>Customer Information</h3>
          <button onClick={startEdit} className='btn-secondary text-sm'>
            Edit
          </button>
        </div>
        <div className='grid grid-cols-2 gap-4'>
          <div>
            <p className='text-sm text-gray-500'>Name</p>
            <p className='font-medium text-gray-900'>{data.name}</p>
          </div>
          <div>
            <p className='text-sm text-gray-500'>Email</p>
            <p className='font-medium text-gray-900'>{data.email || '-'}</p>
          </div>
          <div>
            <p className='text-sm text-gray-500'>Phone</p>
            <p className='font-medium text-gray-900'>{data.tel || '-'}</p>
          </div>
          <div>
            <p className='text-sm text-gray-500'>Address</p>
            <p className='font-medium text-gray-900'>
              {[data.street, data.house_number].filter(Boolean).join(' ') || '-'}
              <br />
              {[data.zip, data.city].filter(Boolean).join(' ')}
            </p>
          </div>
          <div>
            <p className='text-sm text-gray-500'>Created</p>
            <p className='font-medium text-gray-900'>
              {data.created_at ? new Date(data.created_at).toLocaleDateString('en-GB') : '-'}
            </p>
          </div>
        </div>
      </div>
    </div>
  );
};

export default CustomerDetails;
